import { FONT_WEIGHT, COLOR } from '@bugbug/core/theme';
import {
  Step as MuiStepBase,
  StepLabel as MuiStepLabelBase,
  Stepper as MuiStepperBase,
} from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  width: 840px;
`;

export const Title = styled.p`
  margin: 0;
  font-weight: ${(props) => props.theme.fontWeight.bold};
  font-size: 18px;
  line-height: 27px;
  margin-bottom: 4px;
`;

export const Description = styled.p`
  margin: 0;
  margin-bottom: 16px;
`;

export const CheckoutNavigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px 0;
  position: relative;

  button {
    width: 128px;
  }

  button > div {
    flex: none;
  }

  button + button {
    margin-left: 9px;
  }

  svg {
    position: absolute;
    left: 0;
  }
`;

export const FormWrapper = styled.div`
  max-width: 500px;
`;

export const StepDetailsContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 780px;
  flex: 1;
`;

export const StepDetailsSection = styled.div`
  display: flex;
  gap: 96px;
  align-items: flex-start;
`;

export const Stepper = styled(MuiStepperBase)`
  && {
    padding-top: 14px;
    padding-bottom: 36px;
    height: 97px;
    max-width: 780px;
    width: 100%;
    margin-left: -8px;

    .MuiStepConnector-line {
      margin: 0px 5px;
      border-top-width: 2px;
      border-color: ${COLOR.GRAY_9};
    }
  }
`;

export const Step = styled(MuiStepBase)``;

export const StepLabel = styled(MuiStepLabelBase)`
  && {
    .MuiStepLabel-label {
      color: ${COLOR.GRAY_13};
      font-size: 15px;
      line-height: 18px;
      font-weight: ${FONT_WEIGHT.SEMIBOLD};
      text-transform: uppercase;
      transition: color 200ms ease-in-out;
    }

    .MuiStepLabel-active {
      color: ${COLOR.DARK_GRAY};
      font-weight: ${FONT_WEIGHT.SEMIBOLD};
    }

    .MuiStepIcon {
      transition: color 200ms ease-in-out;
      color: #a3adb8;
      font-weight: ${FONT_WEIGHT.SEMIBOLD};
    }

    .MuiStepIcon-active,
    .MuiStepIcon-completed {
      color: ${COLOR.PRIMARY_LIGHT};
    }

    .MuiStepIcon-text {
      font-weight: ${FONT_WEIGHT.SEMIBOLD};
    }
  }
`;
